import React, { useEffect, useState } from "react";
import { Table, UncontrolledTooltip, Row, Col } from "reactstrap";
import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import { RiBuilding4Line, RiInformationLine } from "react-icons/ri";

const RelatedLegalEntities = ({
    t,
    activeAccordion, 
    setActiveAccordion,
    infoQuery
}) => {
    const [ team, setTeam ] = useState([]);

    useEffect(() => {
        if (infoQuery.data?.company_shareholders) {
            setTeam(
                infoQuery.data.company_shareholders.filter((holder) => holder.companyType === 'global') 
            )
        }
    }, [ infoQuery.data ]);

    if (infoQuery.isFetching) {
        return (
            <Row>
                <Col 
                    sm="12" 
                    className="mt-4 mb-4"
                >
                    <div 
                        className="dt-field dt-skeleton" 
                        style={{ width: '100%', height: '100px' }}
                    />
                </Col>
            </Row>
        )
    }

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('legal-entities')}
            className={activeAccordion === 'legal-entities' ? 'active' : ''}
            eventKey={'legal-entities'}
        >
            <Accordion.Header>
                <RiBuilding4Line size="24" className="me-2" />
                <span>
                    {t('Related Legal Entities')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <div className="shareholders-section mb-5" role="region" aria-labelledby="shareholders-heading">

                    <Table hover>
                        <thead>
                            <tr>
                                <th>
                                    {t('Company Name')}
                                </th>
                                <th>
                                    <span className="me-1">
                                        {t('DUNS Number')}
                                    </span>
                                    <RiInformationLine
                                        id="dunsTip"
                                        size={14}
                                    />
                                    <UncontrolledTooltip
                                        target="dunsTip"
                                    >
                                        {t('The D-U-N-S® Number (Data Universal Numbering System) is a unique nine-digit identifier for businesses, issued by Dun & Bradstreet, used to verify and track company information globall.')}
                                    </UncontrolledTooltip>
                                </th>
                                <th>
                                    {t('Street Address')}
                                </th>
                                <th>
                                    {t('Postal Code')}
                                </th>
                                <th>
                                    {t('City')}
                                </th>
                                <th>
                                    {t('Region / State')}
                                </th>
                                <th>
                                    {t('Region Short')}
                                </th>
                                <th>
                                    {t('Region Code')}
                                </th>
                                <th>
                                    {t('Country')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {team.length > 0 ? (
                                team.map((company) => (
                                    <tr key={company.id}>
                                        <td>{company.name || "-"}</td>
                                        <td>{company.duns || "-"}</td>
                                        <td>{company.address || "-"}</td>
                                        <td>{company.postcode || "-"}</td>
                                        <td>{company.city || "-"}</td>
                                        <td>{company.region || "-"}</td>
                                        <td>{company.regionShort || "-"}</td>
                                        <td>{company.regionCode || "-"}</td>
                                        <td>
                                            {`${company.country}${company.countryIso ? ` (${company.countryIso})` : ''}`}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10">
                                        <div className="text-center">
                                            <p>{t('No legal entities found.')}</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
}

export default withNamespaces()(RelatedLegalEntities);
